module.exports = __webpack_public_path__ + "static/media/stormwindBg.8f8bdee5.jpg";